import { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import {
  woundAssessmentReEvalAsync,
  ne1updateassessmentsignlockAsync,
  signLockAsync,
  detailAssessmentAsync,
  validatecharacteristicsAsync,
  woundAssessmentUpdateAsync,
} from "../../../../app/patientSlice";
import { lockSuccessAsyncData } from "../../../../utils/patientsHelper";
import { DISCHARGED } from "../../../../constants";
import { usePermissions } from "../../../../hooks/usePermissions";
// import { getSignButtonStatus } from "../../../../utils/getSignButtonStatus";
import { useLoading } from "../../../../hooks/useLoading";
import { LOADING_KEYS } from "../../../../constants/loadingKeys";

export const MODAL_TYPES = {
  LOCK: "LOCK",
  RE_EVAL: "RE_EVAL",
  MIN_DATASET: "minDataSignComplete",
};

export const useSignAndLock = () => {
  const dispatch = useDispatch();
  const { patientId, assessmentId } = useParams();
  const { hasPermission } = usePermissions();

  const signAndLockLoading = useLoading(LOADING_KEYS.SIGN_LOCK_LOADING);

  const detailViewData = useSelector((state) => state.patient.detailViewData);
  // const minimumDatasetInfo = useSelector((s) => s.patient.minimumDatasetInfo);
  const assessmentDetail = useSelector((state) => state.patient.detailAssessment);

  // const checkLock = useSelector((state) => state.patient.checkLock);
  const ne1configsignwithoutmindatasetData = useSelector((state) => state.patient.ne1configsignwithoutmindataset);
  const ne1getWounAssessmentDetailData = useSelector((state) => state.patient.ne1getWounAssessmentDetail);
  const minDataSet = ne1configsignwithoutmindatasetData?.isSignWithOutMinimumDataset;

  // const { isSign, pendingItems } = getSignButtonStatus(detailViewData?.signCriteria, minimumDatasetInfo, assessmentDetail?.signWithOutMinimumDataset);

  // const signed = assessmentDetail?.signed === 1;
  // const locked = assessmentDetail?.locked === 1;
  const isDischarged = detailViewData?.statusInfo?.status === DISCHARGED;

  const [sign, setSign] = useState(false);
  const [lock, setLock] = useState(false);

  const [signed, setSigned] = useState(false);
  const [locked, setLocked] = useState(false);

  // Modal state
  const [showModal, setShowModal] = useState(false);
  const [modalType, setModalType] = useState(null);
  const [isSignAndLock, setIsSignAndLock] = useState(false);

  // Dropdown state
  const [viewDrop, setViewDrop] = useState(false);
  const dropRef = useRef();

  const getCharDetails = () => {
    // Assign it to payload
    const payload = { patientId, assessmentId };
    // Dispatching get assessment details call
    dispatch(detailAssessmentAsync(payload));
  };

  useEffect(() => {
    const payload = { patientId, assessmentId, type: "signlockactions" };
    // To get details about what butotn to display
    dispatch(signLockAsync(payload));
    // getCharDetails();
  }, [dispatch]);

  useEffect(() => {
    if (ne1configsignwithoutmindatasetData?.isAssessmentWithMinimumDatasetDone === 1 && ne1getWounAssessmentDetailData?.isSignedDetailDone === 0) {
      setSign(true);
      setLock(false);
    }
    if (ne1getWounAssessmentDetailData?.isSignedDetailDone === 1 && ne1getWounAssessmentDetailData?.isSignedLockedDetailDone === 0) {
      setSign(false);
      setLock(true);
    }
    // if (assessmentDetail?.signed === 1 && ((assessmentDetail?.classification?.woundBedIdentifiable === null && assessmentDetail?.classification?.woundClassification !=="Unknown") || ((assessmentDetail?.classification?.woundBedIdentifiable===0 || assessmentDetail?.classification?.woundBedIdentifiable === 1) && assessmentDetail?.classification?.woundClassification !=="Unknown"))) {
    if (ne1getWounAssessmentDetailData?.isSignedDetailDone === 1) {
      setSigned(true);
    } else if (ne1getWounAssessmentDetailData?.isSignedDetailDone === 0) {
      setSigned(false);
    }
    //if (assessmentDetail?.locked === 1 && ((assessmentDetail?.classification?.woundBedIdentifiable === null && assessmentDetail?.classification?.woundClassification !=="Unknown") || ((assessmentDetail?.classification?.woundBedIdentifiable===0 || assessmentDetail?.classification?.woundBedIdentifiable === 1) && assessmentDetail?.classification?.woundClassification !=="Unknown"))) {

    if (ne1getWounAssessmentDetailData?.isSignedLockedDetailDone === 1) {
      setLocked(true);
    } else if (ne1getWounAssessmentDetailData?.isSignedLockedDetailDone === 0) {
      setLocked(false);
    }

    //ne1configsignwithoutmindatasetAsync
    /* signLockActions && signLockActions.length > 0 && signLockActions.map((data) => {
      if (data.key === 'sign') {
          if (data.enable === 1) {
              setSign(true)
              setLock(false)
          }
          if (data.enable === 0) {
              setSign(false)
              setLock(false)
          }
      }
      if (data.key === 'signlock') {
          if (data.enable === 1 || data.enable === 0) {
              setLock(true)
          }
      }
      if (data.enable === 1 )
       setIsSignMinPopShow(data?.enable )
  })*/
  });

  const modalOpen = (e, type) => {
    e.preventDefault();
    setModalType(type);
    setShowModal(true);
  };

  const modalClose = () => {
    setShowModal(false);
  };

  const handleSign = (e) => {
    e.preventDefault();
    setViewDrop(false);

    const assessment = {
      ...assessmentDetail,
      assessmentStage: "pendingreview",
      signed: 1,
    };
    const payload = { patientId, assessmentId, assessment, setSigned, setLock, getCharDetails };
    dispatch(ne1updateassessmentsignlockAsync(payload));
    modalClose();
  };

  const handleCheckSign = (e) => {
    const payload = { patientId, assessmentId };
    // Dispatching get assessment details call
    dispatch(detailAssessmentAsync(payload));
    e.preventDefault();
    if (minDataSet === 1) {
      const payload = {
        patientId,
        assessmentId,
      };
      dispatch(validatecharacteristicsAsync(payload, e, modalOpen, handleSign));
    } else {
      handleSign(e);
    }
  };

  const lockSuccessAsync = () => {
    lockSuccessAsyncData(
      setSigned,
      setLocked,
      assessmentDetail,
      patientId,
      assessmentId,
      getCharDetails,
      dispatch,
      woundAssessmentUpdateAsync,
      ne1updateassessmentsignlockAsync,
      isSignAndLock
    );
  };

  const lockFailAsync = () => {
    setModalType("error");
    setShowModal(true);
  };

  const checkLockAsync = () => {
    const payload = { patientId, assessmentId, type: "checklock", lockSuccessAsync, lockFailAsync };
    // To get details about what butotn to display
    dispatch(signLockAsync(payload));
  };

  const handleContinue = (e) => {
    modalClose();
    checkLockAsync();
    // lockSuccessAsyncData(assessmentDetail, patientId, assessmentId, dispatch, ne1updateassessmentsignlockAsync, isSignAndLock);
  };

  const handleDrop = (e) => {
    e.preventDefault();
    setViewDrop((prev) => !prev);
  };

  const handleReEval = (e) => {
    e.preventDefault();
    const payload = { patientId, assessmentId };
    dispatch(woundAssessmentReEvalAsync(payload));
  };

  const handleReEvalMsg = (e) => {
    e.preventDefault();
    modalOpen(e, MODAL_TYPES.RE_EVAL);
  };

  const handleContinueReEval = (e) => {
    modalClose();
    handleReEval(e);
  };

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (dropRef.current && !dropRef.current.contains(e.target)) {
        setViewDrop(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  return {
    // Derived from store
    signed,
    locked,
    sign,
    lock,
    isDischarged,
    // isSign,
    // pendingItems,
    signAndLockLoading,
    assessmentDetail,
    detailViewData,
    // Permissions
    hasPermission,
    // Modal
    showModal,
    modalType,
    modalOpen,
    modalClose,
    // Dropdown
    viewDrop,
    dropRef,
    handleDrop,
    // Sign & lock control
    isSignAndLock,
    setIsSignAndLock,
    // Handlers
    handleSign,
    handleContinue,
    handleReEval,
    handleReEvalMsg,
    handleContinueReEval,
    // old
    minDataSet,
    handleCheckSign
  };
};
